'use client'

import { usePathname } from 'next/navigation'
import ScrollSubscribe from './ScrollSubscribe'

/**
 * Thin client wrapper so the root layout can stay a server component. The
 * slide-in needs the current path for two things: suppressing itself on pages
 * that already ask, and recording which page earned the signup.
 */
export default function NewsletterMount() {
  const pathname = usePathname() ?? '/'
  return <ScrollSubscribe pathname={pathname} />
}
